import { useCallback, useEffect, useRef, useState } from "react";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";

export const useIntroModalGTMEvents = (isFirstShowIntro) => {
    const isIntroVideoEventNeedSend = useRef(isFirstShowIntro);
    
    const { pushGtmEvent } = useGTMEvent();
    
    const handleSendIsPlayedIntroVideoGTMEvent = useCallback((isPlayed) => {
        if (isIntroVideoEventNeedSend.current) {
            pushGtmEvent({
                event: 'playIntroVideo',
                module: 'IntroModal',
                isPlayed
            })
            isIntroVideoEventNeedSend.current = false;
        }
    }, [pushGtmEvent])
    
    useEffect(() => () => {
        if (isIntroVideoEventNeedSend.current) {
            handleSendIsPlayedIntroVideoGTMEvent(false)
        }
    }, [handleSendIsPlayedIntroVideoGTMEvent]);

    return {handleSendIsPlayedIntroVideoGTMEvent}
}

export const useIntroModalContentEvents = ({onContentClick}) => {
    const [isContentClicked, setIsContentClicked] = useState(false);
    const [isContentHovered, setIsContentHovered] = useState(false);

    const handleContentClick = useCallback(() => {
        setIsContentClicked(true);
        if (onContentClick) {
            onContentClick();
        }
    }, [onContentClick]);

    const handleContentMouseEnter = useCallback(() => {
        setIsContentHovered(true);
    }, []);

    const handleContentMouseLeave = useCallback(() => {
        setIsContentHovered(false);
    }, []);

    return {isContentClicked, isContentHovered, handleContentClick, handleContentMouseEnter, handleContentMouseLeave}
}
